/* GarnelenTv Warenkorb + Drawer, 24.09.2026. Quelle: snippets/gtv-drawer-hinweis + gtv-chip-basis. */

  /* Artikelzahl im Drawer-Kopf ohne Thermobox. Das Theme-JS setzt den gebundenen Zähler aus
     cart.js (inkl. Box) und rendert den Kopf nicht neu — deshalb hier aus dem DOM nachrechnen. */
  (function () {
    if (window.gtvZaehler) return; window.gtvZaehler = true;
    function rechne() {
      document.querySelectorAll('[data-ajax-cart-drawer]').forEach(function (d) {
        var gebunden = d.querySelector('[data-bind="itemCount"]'); var eigener = d.querySelector('.gtv-anzahl');
        if (!gebunden || !eigener) return;
        var box = 0;
        d.querySelectorAll('.ajax-cart__product--thermo input[name="quantity"], .ajax-cart__product--thermo .quantity-input').forEach(function (i) { box += parseInt(i.value, 10) || 0; });
        if (!box) box = d.querySelectorAll('.ajax-cart__product--thermo').length;
        var n = (parseInt(gebunden.textContent, 10) || 0) - box; if (n < 0) n = 0;
        // Nur schreiben, wenn sich etwas ändert — sonst löst der Beobachter sich selbst aus.
        if (eigener.textContent !== String(n)) eigener.textContent = String(n);
      });
    }
    /* Mindestbestellmenge (Lucas, 11.09.2026): Minus-Knopf und Chips konnten Mengen unter das
       Metafeld custom.fields_mindestbestellmenge bringen. Jede Zeile trägt data-gtv-min/-qty/-line
       (cart.ajax.liquid). Liegt eine Menge darunter, wird sie auf die Mindestmenge gesetzt —
       wie auf der Warenkorbseite (cart__main). Läuft nach jedem Neu-Rendern des Drawers. */
    var mindestTimer = null;
    function mindest() {
      if (window.gtvMinLaeuft) return;
      var korrigieren = [];
      document.querySelectorAll('[data-ajax-cart-drawer] [data-gtv-min]').forEach(function (z) {
        var min = parseInt(z.getAttribute('data-gtv-min'), 10) || 1;
        var qty = parseInt(z.getAttribute('data-gtv-qty'), 10) || 0;
        var input = z.querySelector('input[name="quantity"], input[type="number"]');
        if (input && min > 1) input.setAttribute('min', String(min));
        if (qty > 0 && qty < min && !korrigieren.some(function (k) { return k.line === parseInt(z.getAttribute('data-gtv-line'), 10); })) korrigieren.push({ line: parseInt(z.getAttribute('data-gtv-line'), 10), min: min, titel: ((z.querySelector('.ajax-cart__product-title') || z.querySelector('a') || {}).textContent || '').trim().slice(0, 40) });
      });
      if (!korrigieren.length) return;
      window.gtvMinLaeuft = true;
      var kette = Promise.resolve();
      korrigieren.forEach(function (k) {
        kette = kette.then(function () {
          return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: k.line, quantity: k.min }) });
        });
      });
      kette.then(function () {
        window.gtvMinLaeuft = false;
        var c = window.PXUTheme && window.PXUTheme.jsAjaxCart;
        if (c) c.updateView();
        alert('Für diese Artikel gilt eine Mindestbestellmenge. Die Menge wurde angepasst:\n' + korrigieren.map(function (k) { return k.titel + ': mindestens ' + k.min + ' Stück'; }).join('\n'));
      }).catch(function () { window.gtvMinLaeuft = false; });
    }
    var obs = new MutationObserver(function () { rechne(); clearTimeout(mindestTimer); mindestTimer = setTimeout(mindest, 400); });
    document.querySelectorAll('[data-ajax-cart-drawer]').forEach(function (d) { obs.observe(d, { childList: true, subtree: true }); });
    rechne(); setTimeout(mindest, 400);
  })();


  /* Einmal pro Seite. Delegiert, damit auch Chips funktionieren, die der Drawer
     nach einer Warenkorbänderung neu rendert. */
  (function () {
    if (window.gtvChipInit) return; window.gtvChipInit = true;

    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-gtv-add]') : null;
      if (!b) return;
      e.preventDefault();
      if (b.disabled) return;
      b.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(b.dataset.gtvAdd, 10), quantity: Math.max(1, parseInt(b.dataset.gtvQty, 10) || 1) }] })
      })
        .then(function (r) { if (!r.ok) { throw new Error('cart/add ' + r.status); } return r.json(); })
        .then(function () {
          b.classList.add('gtv-chip--ok');
          var c = window.PXUTheme && window.PXUTheme.jsAjaxCart;
          if (c) { c.updateView(); c.showDrawer(); } else { window.location.reload(); }
          /* Der Drawer rendert sich neu und ersetzt diesen Button ohnehin;
             das Zurücksetzen greift nur dort, wo er stehen bleibt. */
          setTimeout(function () { b.disabled = false; b.classList.remove('gtv-chip--ok'); }, 1200);
        })
        .catch(function () {
          /* Ausverkauft, Limit erreicht, Netz weg: altes Verhalten als Rückfallebene. */
          b.disabled = false;
          if (b.dataset.gtvUrl) { window.location = b.dataset.gtvUrl; }
        });
    });
  })();

/* ---- Schleife 2: AGB-Haekchen. Vorher: Klick auf Kasse ohne Haken = nichts passiert,
   nur eine Browser-Blase. Jetzt: sichtbarer Hinweis direkt am Haken, Fokus dorthin. ---- */
(function(){
  if (window.gtvAgbInit) return; window.gtvAgbInit = true;
  function zeigeHinweis(box) {
    var halter = box.closest('p, div, label') || box.parentElement;
    halter.classList.add('gtv-agb-fehlt');
    if (!halter.querySelector('.gtv-agb-hinweis')) {
      var h = document.createElement('p'); h.className = 'gtv-agb-hinweis';
      h.textContent = 'Bitte kurz die AGB best\u00e4tigen, dann geht es weiter zur Kasse.';
      halter.appendChild(h);
    }
    box.addEventListener('change', function(){ if (box.checked) halter.classList.remove('gtv-agb-fehlt'); }, { once: true });
    try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
    box.focus();
  }
  function istAgbBox(el) { return el && el.matches && el.matches('#cart_agree, #sliding_agree, .tos_agree'); }

  /* Abnahme 24.09.2026: Bei einem echten Klick prueft der Browser das
     Pflicht-Haekchen selbst und bricht ab, bevor ein submit-Ereignis
     entsteht. Deshalb zusaetzlich auf das invalid-Ereignis hoeren. */
  document.addEventListener('invalid', function (e) {
    var box = e.target; if (!istAgbBox(box) || box.checked) return;
    e.preventDefault();               /* keine Browser-Blase, unser Hinweis stattdessen */
    zeigeHinweis(box);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form || !form.querySelector) return;
    var box = form.querySelector('#cart_agree, #sliding_agree, .tos_agree');
    if (!box || !box.required || box.checked) return;
    e.preventDefault();
    zeigeHinweis(box);
  }, true);
  /* Der Kasse-Knopf im Drawer hat einen eigenen Klick-Handler des Themes, der
     den Klick ohne Haken still verschluckt: kein submit, kein invalid, keine
     Meldung. Deshalb ein Klick-Handler in der Capture-Phase, der vor dem Theme
     laeuft: ohne Haken Hinweis zeigen und den Klick beenden. */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest ? e.target.closest('button[name="checkout"], #checkout') : null;
    if (!knopf) return;
    var form = knopf.closest('form'); if (!form) return;
    var box = form.querySelector('#cart_agree, #sliding_agree, .tos_agree');
    if (!box || !box.required || box.checked) return;
    e.preventDefault(); e.stopPropagation();
    zeigeHinweis(box);
  }, true);

  /* Der Drawer steht zweimal im DOM (Vorlage + sichtbare Kopie), beide mit
     id="sliding_agree". Das Label zeigt per for= auf das erste, unsichtbare
     Kaestchen - ein Tipp auf den Text setzte deshalb nichts. Hier wird das
     Kaestchen im selben Block genommen. */
  document.addEventListener('click', function (e) {
    var label = e.target.closest ? e.target.closest('label.tos_label, label[for="sliding_agree"], label[for="cart_agree"]') : null;
    if (!label) return;
    var ziel = document.getElementById(label.getAttribute('for') || '');
    if (ziel && ziel.getBoundingClientRect().width > 0) return;   /* Label zeigt schon auf das sichtbare */
    var eigenes = (label.closest('p, div') || label.parentElement).querySelector('input[type="checkbox"]');
    if (!eigenes) return;
    e.preventDefault();
    eigenes.checked = !eigenes.checked;
    eigenes.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  /* Gewaehrleistungslabel: Kopfzeile klickbar, oeffnet den Dialog aus layout/theme.liquid.
     Delegiert, weil der Drawer per Ajax immer wieder neu gerendert wird. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-gtv-gwl], [data-gtv-gwl-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-gtv-gwl-close')) { e.preventDefault(); var offen = t.closest('dialog'); if (offen) offen.close(); return; }
    var d = document.getElementById(t.getAttribute('aria-controls') || 'gtv-gwl-dialog');
    if (!d) return;
    e.preventDefault();
    var img = d.querySelector('img');
    if (img && !img.getAttribute('src')) img.src = img.getAttribute('data-src');   /* 88 KB erst beim Oeffnen laden */
    if (typeof d.showModal === 'function') d.showModal();
    else window.open(img.src, '_blank');
  });
  document.addEventListener('click', function (e) {
    if (e.target.matches && e.target.matches('dialog.gtv-gwl-dialog')) e.target.close();   /* Klick auf den Hintergrund schliesst */
  });

  /* Info-i im Drawer (Thermoverpackung): Antippen blendet den Erklaertext ein/aus. Delegiert, weil der Drawer neu gerendert wird. */
  document.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('[data-gtv-info]') : null;
    if (!k) return;
    e.preventDefault(); e.stopPropagation();
    var zeile = k.closest('.gtv-thermo-row');
    var text = zeile && zeile.querySelector('.gtv-thermo-text');
    if (!text) return;
    text.hidden = !text.hidden;
    k.setAttribute('aria-expanded', String(!text.hidden));
  }, true);
})();
